module.exports = __webpack_public_path__ + "./Cecilia_e61721ec9eda968e1182fe019d646b4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Cecilia.jpg
// module id = 518
// module chunks = 0